import { useEffect, useState } from "react";

export function useAsync<T>(
  callback: (...args: any[]) => Promise<T>,
  ...args: any[]
) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [hasBeenCalled, setHasBeenCalled] = useState<boolean>(false);

  useEffect(() => {
    if (hasBeenCalled) return;

    const fetchData = async () => {
      try {
        setLoading(true);
        setHasBeenCalled(true);

        const result = await callback(...args);
        setData(result);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [callback, hasBeenCalled, ...args]);

  return { data, error, loading };
}
